import { useState } from "react";
import type { EvidenceTagKind } from "../../data/evidenceTags";
import { useHotspotStore } from "../state/hotspotSlice";

export interface HotspotDef {
  id: string;
  label: string;
  position: [number, number, number];
  description: string;
  tag: EvidenceTagKind;
  source: string;
}

interface HotspotProps {
  def: HotspotDef;
}

/**
 * Punto de interés interactivo: marcador sobrio clicable que abre en el
 * SidePanel la ficha del objeto con su EvidenceTag. El acceso por teclado
 * se garantiza con la lista paralela de hotspots en el SidePanel.
 */
export function Hotspot({ def }: HotspotProps) {
  const [hovered, setHovered] = useState(false);
  const open = useHotspotStore((s) => s.open);
  const selectedId = useHotspotStore((s) => s.selectedId);
  const active = selectedId === def.id;

  return (
    <group position={def.position}>
      <mesh
        onClick={(e) => {
          e.stopPropagation();
          open(def.id);
        }}
        onPointerOver={(e) => {
          e.stopPropagation();
          setHovered(true);
          document.body.style.cursor = "pointer";
        }}
        onPointerOut={() => {
          setHovered(false);
          document.body.style.cursor = "auto";
        }}
        userData={{ hotspotId: def.id, label: def.label }}
      >
        <sphereGeometry args={[0.11, 16, 16]} />
        <meshStandardMaterial
          color={active ? "#d9a441" : hovered ? "#2a8c8e" : "#2f6364"}
          emissive={active || hovered ? "#1f7a7c" : "#123"}
          emissiveIntensity={active || hovered ? 0.7 : 0.25}
          transparent
          opacity={0.92}
        />
      </mesh>
      {/* vástago corto: ubica el marcador sin invadir la escena */}
      <mesh position={[0, -0.2, 0]}>
        <cylinderGeometry args={[0.012, 0.012, 0.26, 6]} />
        <meshStandardMaterial color="#2f6364" roughness={0.6} transparent opacity={0.8} />
      </mesh>
    </group>
  );
}
